// "Is this conversation on screen?": a normal route renders its own id; the Alerts route
// renders only what its context pane shows (the route's activeId is stale there).
// Plain .ts so it is testable under plain-node vitest.

export type RenderedKind = "channel" | "dm" | "agent";
export interface PaneConversation {
  kind: RenderedKind;
  id: string;
}

// The conversation kind the current route names (undefined: Tasks, Pages, Settings, Alerts...).
// The channel/DM stores keep their LAST activeId on every other route, including a route of a
// different kind (a channel id on /agent/<id>), so an id match alone never means "on screen".
export function routeConversationKind(pathname: string): RenderedKind | undefined {
  const m = /^\/workspace\/[^/]+\/(channel|dm|agent)(?:[/?#]|$)/.exec(pathname);
  return m ? (m[1] as RenderedKind) : undefined;
}

export function conversationRendered(i: {
  onAlerts: boolean;
  /** routeConversationKind(pathname): the normal route renders only a conversation of ITS kind */
  routeKind: RenderedKind | undefined;
  /** what the Alerts context pane currently shows (alertsPaneState.conversation) */
  pane: PaneConversation | null;
  kind: RenderedKind;
  id: string | null | undefined;
  /** the id the normal route holds for this kind (channelState.activeId / dmState.activePeerId / URL agent id) */
  routeId: string | null | undefined;
  /** id equality; agent ids need cybo canonicalization */
  eq?: (a: string, b: string) => boolean;
}): boolean {
  if (!i.id) return false;
  const eq = i.eq ?? ((a: string, b: string) => a === b);
  if (i.onAlerts) return i.pane?.kind === i.kind && eq(i.pane.id, i.id);
  return i.routeKind === i.kind && !!i.routeId && eq(i.routeId, i.id);
}
